import ACTIONS from '../actionTypes/release'
import ReleaseService from '../../services/ReleaseService'

export const createRelease = (release) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_CREATE_RELEASE })

    return ReleaseService.createRelease(release).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.CREATE_RELEASE_SUCCESS, payload: res.data })
        return res.data
      } else {
        dispatch({ type: ACTIONS.CREATE_RELEASE_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.CREATE_RELEASE_FAILED })
    })
  }
}

export const getPendingReviews = (page = 1, pageSize = 200) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_GET_REVIEW_LIST })

    return ReleaseService.getPendingReviews(page, pageSize).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.GET_REVIEW_LIST_SUCCESS, payload: res.data })
      } else {
        dispatch({ type: ACTIONS.GET_REVIEW_LIST_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.GET_REVIEW_LIST_FAILED })
    })
  }
}

export const getReleaseById = (releaseId) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_GET_RELEASE_BY_ID })

    return ReleaseService.getReleaseById(releaseId).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.GET_RELEASE_BY_ID_SUCCESS, payload: res.data })
      } else {
        dispatch({ type: ACTIONS.GET_RELEASE_BY_ID_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.GET_RELEASE_BY_ID_FAILED })
    })
  }
}

export const getAdminCommentsByApplicationId = (globalApplicationId)=>{
  return (dispatch) =>{
    dispatch({ type: ACTIONS.START_ADMIN_COMMENTS_FOR_APPLICATION })

    return ReleaseService.getAdminCommentsByApplicationId(globalApplicationId).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.GET_ADMIN_COMMENTS_FOR_APPLICATION_SUCCESS, payload: res.data })
      } else {
        dispatch({ type: ACTIONS.GET_ADMIN_COMMENTS_FOR_APPLICATION_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.GET_ADMIN_COMMENTS_FOR_APPLICATION_FAILED })
    })
  }
}

export const submitReviewForRelease = (releaseId, approve, comment) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_SUBMIT_REVIEW_FOR_RELEASE })

    return ReleaseService.submitReviewForRelease(releaseId, approve, comment).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.SUBMIT_REVIEW_FOR_RELEASE_SUCCESS, payload: res.data })
        return res
      } else {
        dispatch({ type: ACTIONS.SUBMIT_REVIEW_FOR_RELEASE_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.SUBMIT_REVIEW_FOR_RELEASE_FAILED })
    })
  }
}

export const getReleasesForApplication = (globalApplicationId, additionalODataFilter = null) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_GET_RELEASES_FOR_APP })

    return ReleaseService.getReleasesForApplication(globalApplicationId, additionalODataFilter).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.GET_RELEASES_FOR_APP_SUCCESS, payload: res.data })
        return res
      } else {
        dispatch({ type: ACTIONS.GET_RELEASES_FOR_APP_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.GET_RELEASES_FOR_APP_FAILED })
    })
  }
}

